import { Link } from "react-router-dom"
import { ChevronDown } from "lucide-react"

/**
 * Accordion-style disclaimer shown at the bottom of every blog post.
 * Uses native <details>/<summary> for zero-JS progressive enhancement.
 */
export function BlogDisclaimer() {
  return (
    <details className="mt-8 border rounded-lg print:hidden group">
      <summary className="flex items-center justify-between cursor-pointer px-4 py-3 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors select-none list-none [&::-webkit-details-marker]:hidden">
        Disclaimer
        <ChevronDown className="h-4 w-4 transition-transform group-open:rotate-180" />
      </summary>
      <div className="px-4 pb-4 text-xs text-muted-foreground leading-relaxed space-y-2 border-t pt-3">
        <p>
          The information provided is for informational and educational purposes only and does not constitute financial, investment, legal, or tax advice. All opinions expressed are solely those of the WELEPHANT team and are based on publicly available information and personal analysis.
        </p>
        <p>
          We may hold positions in the cryptocurrencies, tokens, or protocols discussed, and these positions may change at any time without notice. WELEPHANT.XYZ is a decentralized prediction mining game involving cryptocurrency — participation carries risk, including the potential loss of all funds deposited. Smart contracts may contain bugs or vulnerabilities, blockchain transactions are irreversible, and cryptocurrency values are highly volatile. Past performance is not indicative of future results.
        </p>
        <p>
          Nothing published here constitutes a solicitation or recommendation to participate in any protocol or purchase any digital asset. Any decisions you make should be based on your own research and risk tolerance. Please review our{" "}
          <Link to="/terms" className="text-primary hover:underline">Terms of Service</Link> for full details.
        </p>
      </div>
    </details>
  )
}
